import { makeAutoObservable } from 'mobx'

export default class GlobalStore {
    fullScreenMode = false
    isMobile = false
    topbar = false
    accountStatus = ''

    constructor() {
        makeAutoObservable(this)
    }

    setAccountStatus = (status) => {
        this.accountStatus = status
    }

    toggleFullScreen = () => {
        this.fullScreenMode = !this.fullScreenMode
        const documentFullScreenMode = document.fullscreenElement !== null
        if (this.fullScreenMode)
            document.documentElement.requestFullscreen()
        else {
            if (documentFullScreenMode)
                document.exitFullscreen()
        }
    }
}


